import { connect } from 'react-redux';

import { accountUtils } from '@talend/dataset';
import {
	initDemoContent,
	getDemoContentState,
	getDemoContentSteps,
} from '@talend/dataset/lib/modules/DemoContent';
import { enginesSelectors } from '@talend/engines';

import { closeGuidedTourHome, initializeGuidedTour } from '../../service/GuidedTour.actions';
import { isGuidedTourOpened } from '../../service/GuidedTour.selector';
import { GuidedTourHome } from './GuidedTourHome.component';

export const mapStateToProps = (state: any) => {
	const isSnowflake = accountUtils.isSnowflakeUser();
	const isEngineUnavailable = enginesSelectors.isOneEngineAvailable(state);

	return {
		isOpen: isGuidedTourOpened(state) && (isEngineUnavailable || isSnowflake),
		demoContentSteps: isSnowflake
			? null
			: getDemoContentState(state).steps || getDemoContentSteps(),
		isSnowflake,
	};
};

export const mapDispatchToProps = {
	onRequestOpen: initializeGuidedTour,
	onImportDemoContent: () => initDemoContent('/demo-content.zip', getDemoContentSteps()),
	onRequestClose: closeGuidedTourHome,
};

export const ConnectedGuidedTourHome = connect(mapStateToProps, mapDispatchToProps)(GuidedTourHome);
